import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const supplier_reports = apiUrl + "/supplier_reports";
const routes = {
  label: "Supplier Reports",
  root: supplier_reports,
  new: supplier_reports + "/new",
  get_mine_received: supplier_reports + "/get_mine_received",
  get_mine_sent: supplier_reports + "/get_mine_sent",
  has_mine_pending: supplier_reports + "/has_mine_pending",
  accept: supplier_reports + "/accept",
  reject: supplier_reports + "/reject",
  update_type: supplier_reports + "/update_type",
};

export const Supplier_Reports = {
  new: (supplier_report) => postWithToken(routes.new, supplier_report),
  get_mine_received: () => postWithToken(routes.get_mine_received),
  get_mine_sent: () => postWithToken(routes.get_mine_sent),
  has_mine_pending: () => postWithToken(routes.has_mine_pending),
  accept: (id) => postWithToken(routes.accept, { id }),
  reject: (id) => postWithToken(routes.reject, { id }),
  update_type: (id, type) => postWithToken(routes.update_type, { id, type }),
};
